module.exports = __webpack_public_path__ + "static/cloud2-3d785916b2e7c885b90b3dc7453715cc.png";